import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, Input, Button, Row, Col, Select } from 'antd';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import libphonenumber from 'google-libphonenumber';
import { withCookies } from 'react-cookie';
import axios from 'axios';
import countries from '../../utils/countryCodes';
import messages from '../../utils/commonwords';
import { createAccount } from '../../store/auth/actions';
import { changeLang } from '../../store/intl/actions';
import { REACT_RECAPTCHA_SITE_KEY, SSO_URL } from '../../config/environment';
import styles from './styles.module.scss';
const FormItem = Form.Item;
const Option = Select.Option;

const industries = [
  'Agriculture',
  'Arts, Entertainment, and Recreation',
  'Automobile',
  'Aviation',
  'Construction',
  'Ecommerce',
  'Education',
  'Finance',
  'Gaming',
  'Government',
  'Health Services',
  'Hospitality',
  'Information Technology',
  'Insurance',
  'Manufacturing',
  'Media',
  'Natural Resources and Mining',
  'Non-Profit Organization',
  'Oil & Gas',
  'Pharmaceutical',
  'Professional and Business Services',
  'Real Estate'
];

class SignUp extends React.Component {
  state = {
    country: {
      location: {},
      country_code: ''
    },
    recaptcha: null
  };

  componentDidMount() {
    axios({
      method: 'post',
      url: `${SSO_URL}/ipinfo`,
      json: true
    })
      .then(info => {
        if (info.data.country_name) {
          this.setState({ country: info.data, fetching: false });
        } else {
          this.setState({ country: { location: {} }, fetching: false });
        }
      })
      .catch(err => {
        this.setState({
          country: {},
          fetching: false
        });
      });
    window.recaptchaOptions = {
      lang: this.props.intl.locale,
      useRecaptchaNet: true
    };
  }

  onChangeRecap = value => {
    this.setState({
      recaptcha: value
    });
  };

  asyncEmail = (rule, value, callback) => {
    if (!value) {
      callback();
    }
    if (value) {
      return fetch(`${SSO_URL}/auths/users?email=${value}`, {
        headers: new Headers({
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      })
        .then(response => response.json())
        .then(json => {
          if (json.statusCode === 200) {
            callback(`${value} already exists`);
          }
        })
        .catch(error => {
          callback(`An error occurred`);
        });
    }
  };

  asyncMsisdn = phone => {
    return axios({
      method: 'get',
      url: `${SSO_URL}/auths/users?msisdn=${phone.slice(1).trim()}`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(response => {
        if (response.data.statusCode === 200) {
          return `${response.data.message}`;
        }
      })
      .catch(error => {
        return `An error occurred`;
      });
  };

  checkNumber = phone => {
    try {
      return libphonenumber.PhoneNumberUtil.getInstance().isPossibleNumber(
        libphonenumber.PhoneNumberUtil.getInstance().parse(phone, '')
      );
    } catch (error) {
      return false;
    }
  };

  isPhoneNumber = phone => {
    try {
      return libphonenumber.PhoneNumberUtil.getInstance().isValidNumber(
        libphonenumber.PhoneNumberUtil.getInstance().parse(phone, '')
      );
    } catch (error) {
      return false;
    }
  };

  checkPhoneNumber = async (rule, value, callback) => {
    const num = this.isPhoneNumber(`${this.props.form.getFieldValue('prefix')}${value}`);
    const state = this.checkNumber(
      `${this.props.form.getFieldValue('prefix')}${value}`
    );

    const val = await this.asyncMsisdn(
      `${this.props.form.getFieldValue('prefix')}${value}`,
      callback
    );
    if (val) {
      callback(val);
    }

    if (!value) {
      callback();
    }
    if (!num) {
      callback(
        this.props.intl.formatMessage(messages.formErrorMsgNotValidPhoneNumber)
      );
    }
    if (!state) {
      callback(
        this.props.intl.formatMessage(messages.formErrorMsgNotValidPhoneNumber)
      );
    }
    callback();
  };

  confirmPassword = (rule, value, callback) => {
    if (!value) {
      callback();
    }

    if (value !== this.props.form.getFieldValue('password')) {
      callback(
        this.props.intl.formatMessage(messages.formErrorMsgMismatchPassword)
      );
    }

    callback();
  };

  handleSubmit = e => {
    e.preventDefault();
    const newPhone = `${this.props.form.getFieldValue(
      'prefix'
    )}${this.props.form.getFieldValue('msisdn')}`;

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.createAccount(this.props.intl, this.props.siteLanguage, {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          msisdn: `%2B${newPhone.trim().slice(1)}`,
          password: values.password,
          country: values.country || this.state.country.country_name,
          organization: values.organization,
          industry: values.industry,
          recaptcha: this.state.recaptcha,
          preferences: {
            language: this.props.siteLanguage || 'en',
            promoCode: this.props.cookies.get('promoCode') || ''
          }
        });
      }
    });
  };
  render() {
    const {
      form: { getFieldDecorator },
      intl
    } = this.props;
    const prefixSelector = getFieldDecorator('prefix', {
      initialValue: `+${
        this.state.country.location && this.state.country.location.calling_code
          ? this.state.country.location.calling_code
          : '233'
      }`
    })(
      <Select
        data-dfs-people-id={'prefix-select'}
        style={{ width: 75 }}
        placeholder="+233"
        showSearch
        onChange={e => {
          this.props.form.setFields({
            country: {
              value: countries.find(country => country.dialCode === e).name
            }
          });
        }}
      >
        {countries.map(country => (
          <Option key={country.countryCode} value={country.dialCode}>
            {country.dialCode}
          </Option>
        ))}
      </Select>
    );

    const countrySelector = getFieldDecorator('country', {
      rules: [
        {
          required: true,
          message: 'Please input your  country'
        }
      ],
      initialValue: `${
        this.state.country && this.state.country.country_code
          ? countries.find(
              country =>
                country.countryCode ===
                this.state.country.country_code.toLowerCase()
            ).name
          : 'Ghana'
      }`
    })(
      <Select
        data-dfs-people-id={'country-select'}
        showSearch
        onChange={e => {
          if (!this.props.form.isFieldTouched('msisdn')) {
            this.props.form.setFields({
              prefix: {
                value: countries.find(country => country.name === e).dialCode
              }
            });
          }
        }}
      >
        {countries.map(country => (
          <Option key={country.countryCode} value={country.name}>
            {country.name}
          </Option>
        ))}
      </Select>
    );

    return (
      <Form onSubmit={this.handleSubmit} className="auth_form">
        <h2 className={styles.formTitle}>
          <FormattedMessage
            defaultMessage="Create an account"
            id="App.Text.Signup"
          />
        </h2>

        <Row gutter={16}>
          <Col span={12}>
            <div>
              <FormItem
                label={
                  <FormattedMessage
                    id="signupForm.FirstName"
                    defaultMessage={'First Name'}
                  />
                }
                colon={false}
              >
                {getFieldDecorator('firstName', {
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(
                        messages.formErrorMsgInputFirstName
                      )
                    }
                  ]
                })(
                  <Input data-dfs-people-id={'firstname-input'} type="text" />
                )}
              </FormItem>
            </div>
          </Col>
          <Col span={12}>
            <div>
              <FormItem
                label={
                  <FormattedMessage
                    id="signupForm.LastName"
                    defaultMessage={'Last Name'}
                  />
                }
                colon={false}
              >
                {getFieldDecorator('lastName', {
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(
                        messages.formErrorMsgInputLastName
                      )
                    }
                  ]
                })(<Input data-dfs-people-id={'lastname-input'} type="text" />)}
              </FormItem>
            </div>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <FormItem
              colon={false}
              label={
                <FormattedMessage
                  id="loginForm.EmailAddressInput"
                  defaultMessage={'Email Address'}
                />
              }
            >
              {getFieldDecorator('email', {
                validate: [
                  {
                    trigger: 'onBlur',
                    rules: [
                      {
                        validator: this.asyncEmail
                      }
                    ]
                  },
                  {
                    trigger: 'onChange',
                    rules: [
                      {
                        required: true,
                        message: intl.formatMessage(
                          messages.formErrorMsgInputEmail
                        )
                      },
                      {
                        type: 'email',
                        message: intl.formatMessage(
                          messages.formErrorMsgCheckEmail
                        )
                      }
                    ]
                  }
                ]
              })(<Input data-dfs-people-id={'email-input'} type="email" />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              colon={false}
              label={
                <FormattedMessage
                  id="signupForm.Organization"
                  defaultMessage={'Organisation'}
                />
              }
            >
              {getFieldDecorator('organization', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(
                      messages.formErrorMsgInputOrgName
                    )
                  }
                ]
              })(
                <Input data-dfs-people-id={'organization-input'} type="text" />
              )}
            </FormItem>
          </Col>
          <Col span={24}>
            <Form.Item colon={false} label={intl.formatMessage({ id: 'Label.Industry', defaultMessage: 'Industry' })}>
              {getFieldDecorator('industry', {
                rules: [
                  { required: true, message: intl.formatMessage({ id: 'required_industry', defaultMessage: 'Please provide industry' }) }
                ]
              })(
                <Select showSearch={industries.length > 5}>
                  {industries.map(industry => (
                    <Select.Option key={industry} value={industry}>{industry}</Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <FormItem
              colon={false}
              label={
                <FormattedMessage
                  id="loginForm.CountryInput"
                  defaultMessage={'Country'}
                />
              }
            >
              {countrySelector}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              label={
                <FormattedMessage
                  id="signupForm.PhoneNumber"
                  defaultMessage={'Phone Number'}
                />
              }
              colon={false}
            >
              {getFieldDecorator('msisdn', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(
                      messages.formErrorMsgInputPhoneNumber
                    )
                  },
                  // {
                  //   validator: this.checkPhoneNumber,
                  //   trigger: 'onBlur'
                  // }
                ]
              })(
                <Input
                  data-dfs-people-id={'msisdn-input'}
                  addonBefore={prefixSelector}
                  // style={{ width: '100%' }}
                />
              )}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <FormItem
              colon={false}
              label={
                <FormattedMessage
                  id="loginForm.PasswordInput"
                  defaultMessage={'Password'}
                />
              }
            >
              {getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(
                      messages.formErrorMsgInputPassword
                    )
                  },
                  {
                    min: 6,
                    message: intl.formatMessage(messages.minPasswordChar)
                  }
                ]
              })(
                <Input.Password
                  data-dfs-people-id={'password-input'}
                  type="password"
                  minLength="6"
                />
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem
              colon={false}
              label={
                <FormattedMessage
                  id="signupForm.ConfirmPassword"
                  defaultMessage={'Confirm Password'}
                />
              }
            >
              {getFieldDecorator('cpassword', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(
                      messages.formErrorMsgConfirmPassword
                    )
                  },
                  {
                    min: 6,
                    message: intl.formatMessage(messages.minPasswordChar)
                  },
                  { validator: this.confirmPassword }
                ]
              })(
                <Input.Password
                  data-dfs-people-id={'cpassword-input'}
                  type="password"
                  minLength="6"
                />
              )}
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <div className="recaptchaDiv">
              <ReCAPTCHA
                data-size="compact"
                ref="recaptcha"
                sitekey={REACT_RECAPTCHA_SITE_KEY}
                onChange={this.onChangeRecap}
              />
            </div>
          </Col>
        </Row>

        <div style={{ marginTop: '.7rem', marginBottom: '1rem' }}>
          <Button
            data-dfs-people-id={'signup-button'}
            block
            type="primary"
            htmlType="submit"
            className="signup-form-button"
            loading={this.props.signing_up}
          >
            <FormattedMessage
              id="signupForm.SignupButton"
              defaultMessage={'Sign up'}
            />
          </Button>
        </div>

        <div className="auth_form_links">
          <p style={{ paddingTop: '5%', textAlign: 'center' }}>
            <FormattedMessage
              id="loginScreen.HaveAccountText"
              defaultMessage={'Already have an account?'}
            />{' '}
            <Link
              data-dfs-people-id={'signin-link'}
              to={`/${this.props.siteLanguage || 'en'}/signin`}
            >
              <FormattedMessage
                id="App.Text.Signin"
                defaultMessage={'Sign in'}
              />
            </Link>
          </p>
        </div>
      </Form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    siteLanguage: state.intl.siteLanguage,
    error_msg: state.auth.error_msg,
    signing_up: state.auth.signingUp
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createAccount: (intl, siteLanguage, user) => {
      dispatch(createAccount(intl, siteLanguage, user));
    },
    changeLang: (lang, url) => {
      dispatch(changeLang(lang, url));
    }
  };
};

const SignUpForm = Form.create()(SignUp);

export default injectIntl(
  withCookies(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SignUpForm)
  )
);
